import React from 'react';
import { Modal, Button } from 'semantic-ui-react';
import { func } from 'prop-types';
import html from './AnnexTemplate';

const AnnexDetails = (props) => {
  const {
    onClose,
  } = props;
  return (
    <Modal open>
      <Modal.Content scrolling>
        <div dangerouslySetInnerHTML={{ __html: html }} />
      </Modal.Content>
      <Modal.Actions>
        <Button primary content="Close" onClick={onClose} />
      </Modal.Actions>
    </Modal>
  );
};

AnnexDetails.propTypes = {
  onClose: func.isRequired,
};

AnnexDetails.defaultProps = {
};

export default AnnexDetails;
